import { Injectable } from '@angular/core';
import { RoleGuard } from '../base/guards/role.guard';
import { Role } from '../models/role';

@Injectable({ providedIn: 'root' })
export class AdminRoleGuard extends RoleGuard {
  protected roles: Role[] = [Role.admin];
}

@Injectable({ providedIn: 'root' })
export class AnyAdminRoleGuard extends RoleGuard {
  protected roles: Role[] = [Role.admin, Role.reviewer, Role.pageContentPublisher, Role.assetContentPublisher];
}
